module.exports = __webpack_public_path__ + "static/media/earth_40.0d221606.png";